import React from 'react'
import { Span } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { localizeCurrency } from '../utils'
import { GridElement } from '../GridElement'
import { GridTable } from '../GridTable'

interface DifferenceTotalProps {
  amount: string
  month: string
}

export const DifferenceTotal: React.FC<DifferenceTotalProps> = ({
  amount,
  month,
}) => {
  const { t } = useTranslation(['payments'])
  const amountNumber = Number(amount)
  const hasArrear = amountNumber < 0
  const hasAdvance = amountNumber > 0
  const totalLabel = hasAdvance
    ? t('payments:advanceTotalForMonth', { month })
    : t('payments:arrearTotalForMonth', { month })

  return (
    <GridTable className="mt-12 desktop:mt-16">
      <GridElement columns={2}>
        <Span
          bold
          className={classNames('text-2xl', {
            'text-common-blue-6': hasAdvance,
            'text-common-red-6': hasArrear,
            'text-common-gray-6': !hasAdvance && !hasArrear,
          })}
        >
          {totalLabel}
        </Span>
      </GridElement>
      <GridElement columns={2} align="right">
        <Span
          bold
          className={classNames('p-2 rounded-md text-2xl', {
            'text-common-blue-6': hasAdvance,
            'bg-common-blue-2': hasAdvance,
            'text-common-red-6': hasArrear,
            'bg-common-red-2': hasArrear,
            'text-common-gray-6': !hasAdvance && !hasArrear,
          })}
        >
          {localizeCurrency(Math.abs(amountNumber))}
        </Span>
      </GridElement>
    </GridTable>
  )
}
